<template>
  <div :class="[$style.container, $style[theme]]">
    <a :href="urls.googleMap" target="_blank" @click.stop><img :src="urls.static" :alt="message.content.body" /></a>
    <div v-html="description" :class="[$style.description, $style[theme]]" @click.stop></div>
  </div>
</template>

<script>
const KEY = 'ck2OXUAJsF0iz999XGQ62jyXo8AXOVp7'
const getStaticImageUrl = (lat, lng) =>
  `https://www.mapquestapi.com/staticmap/v5/map?key=${KEY}&locations=${lat},${lng}&size=320,320`

const getGoogleMapsUrl = (lat, lng) => `https://www.google.com.ua/maps/@${lat},${lng},14z`

export default {
  name: 'message-content-location-matrix',
  props: {
    message: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      default: ''
    }
  },
  computed: {
    description () {
      const text = this.message.content.formatted_body || this.message.content.body.replace('\n', '<br />')
      return text.replaceAll('<a', '<a target="_blank"')
    },
    urls () {
      const [lat, lng] = this.message.content.geo_uri.split(':')[1].split(',')
      return { static: getStaticImageUrl(lat, lng), googleMap: getGoogleMapsUrl(lat, lng) }
    }
  }
}
</script>

<style module lang="scss">
.container {
  font-size: 14px;
  width: min-content;
}
.description {
  padding: 8px;
}
</style>
